import type { LegalCopy } from '../types'

export const mr: LegalCopy = {
  title: 'कायदेशीर मदत',
  subtitle: 'नेहमीच्या कायदेशीर अडचणी, सोप्या शब्दांत. तुमच्या भाषेत ऐका, आणि प्रत्येक उत्तराचा सरकारी स्रोत पाहा.',
  helplinesTitle: 'हेल्पलाइन (मोफत कॉल)',
  helplines: {
    emergency: 'आणीबाणी: पोलीस, अग्निशमन, रुग्णवाहिका',
    legal_aid: 'मोफत कायदेशीर मदत (NALSA)',
    cyber: 'ऑनलाइन / UPI फसवणूक',
    women: 'महिला हेल्पलाइन',
    consumer: 'ग्राहक हेल्पलाइन'
  },
  faqTitle: 'नेहमीचे प्रश्न',
  searchPlaceholder: 'शोधा: FIR, फसवणूक, RTI, वकील…',
  noMatch: 'कोणताही प्रश्न जुळला नाही. खाली तुमचा प्रश्न विचारा.',
  sources: 'सरकारी स्रोत',
  listen: 'ऐका',
  askTitle: 'तुमचा कायदेशीर प्रश्न विचारा',
  askHint: 'समझो फक्त सरकारी वेबसाइटवरूनच उत्तर देते, स्रोताच्या लिंकसह.',
  starters: ['मला मोफत वकील मिळू शकतो का?', 'कोणीतरी मला ऑनलाइन फसवले. मी काय करू?', 'पोलीस माझी तक्रार लिहून घेत नाहीत. मी काय करू शकतो?'],
  disclaimer:
    'ही सरकारी स्रोतांमधील सर्वसाधारण माहिती आहे, तुमच्या केससाठी कायदेशीर सल्ला नाही. तुमच्या केससाठी वकिलाशी बोला — विधी सेवा प्राधिकरणाकडून (15100) तुम्हाला मोफत वकील मिळू शकतो.',
  topics: {
    get_free_aid: {
      q: 'मोफत कायदेशीर मदत कशी मिळेल?',
      a: 'NALSA च्या मोफत हेल्पलाइन 15100 वर कॉल करा. किंवा तुमच्या जिल्हा न्यायालयातील विधी सेवा प्राधिकरणाच्या कार्यालयात, किंवा तालुका न्यायालयातील विधी सेवा समितीकडे जा. तुम्ही ऑनलाइन, पोस्टाने किंवा ई-मेलनेही अर्ज करू शकता. अर्ज मोफत आहे, आणि वकिलाची फी व कोर्टाचा खर्च तुमच्यासाठी भरला जातो.'
    },
    who_free_aid: {
      q: 'मोफत वकील कोणाला मिळू शकतो?',
      a: 'कायदा (विधी सेवा प्राधिकरण अधिनियमाचे कलम 12) यांना मोफत कायदेशीर मदत देतो: महिला आणि मुले, SC/ST चे लोक, दिव्यांग व्यक्ती, औद्योगिक कामगार, मानवी तस्करी किंवा वेठबिगारीचे बळी, आपत्ती, जातीवरून होणारे अत्याचार किंवा वांशिक हिंसाचाराचे बळी, कोठडीत असलेले लोक, आणि ज्यांचे वार्षिक उत्पन्न त्यांच्या राज्याने ठरवलेल्या मर्यादेपेक्षा कमी आहे असे लोक. उत्पन्नाची मर्यादा प्रत्येक राज्यात वेगळी आहे.'
    },
    fir: {
      q: 'पोलीस माझी FIR नोंदवत नाहीत. मी काय करू?',
      a: 'गंभीर (दखलपात्र) गुन्ह्याची तक्रार तुम्ही कोणत्याही पोलीस ठाण्यात करू शकता, गुन्हा दुसरीकडे घडला असला तरी — याला झिरो FIR म्हणतात. पोलिसांनी तुम्हाला FIR ची प्रत मोफत द्यायलाच हवी. पोलिसांनी नकार दिला, तर तुमची तक्रार लिहून पोस्टाने पोलीस अधीक्षकांना (SP) पाठवा. SP नीही काही केले नाही, तर तुम्ही प्रतिज्ञापत्रासह मॅजिस्ट्रेटकडे अर्ज करू शकता.'
    },
    cyber_fraud: {
      q: 'ऑनलाइन किंवा UPI फसवणुकीत माझे पैसे गेले. मी काय करू?',
      a: 'लगेच 1930 वर कॉल करा — ही राष्ट्रीय सायबर गुन्हे हेल्पलाइन आहे, मोफत आहे आणि दिवस-रात्र चालू असते. लवकर तक्रार केल्याने पैसे पुढे पाठवले जाण्यापासून थांबवायला मदत होते. तसेच cybercrime.gov.in वर “Financial Fraud” मध्ये तक्रार नोंदवा.'
    },
    women: {
      q: 'एखादी महिला हिंसा किंवा छळ सहन करत आहे. तिला मदत कुठे मिळेल?',
      a: 'आणीबाणीत पोलीस, अग्निशमन किंवा रुग्णवाहिकेसाठी 112 डायल करा. मोफत महिला हेल्पलाइन 181 वर दिवस-रात्र कधीही कॉल करा. तुम्ही तुमचे नाव गुप्त ठेवू शकता, आणि ही हेल्पलाइन तुम्हाला पोलीस, वन स्टॉप सेंटर, रुग्णालय किंवा कायदेशीर मदतीशी जोडते. राष्ट्रीय महिला आयोगाचीही हेल्पलाइन 14490 आहे, आणि आयोग ऑनलाइन तक्रारीही स्वीकारतो.'
    },
    consumer: {
      q: 'दुकानाने किंवा कंपनीने मला फसवले. तक्रार कुठे करू?',
      a: 'राष्ट्रीय ग्राहक हेल्पलाइन 1915 वर कॉल करा (मोफत, सकाळी 8 ते रात्री 8), 8800001915 वर WhatsApp संदेश पाठवा, किंवा consumerhelpline.gov.in वर तक्रार करा. ग्राहक आयोगात केस दाखल करायची असेल, तर e-Daakhil वर ऑनलाइन करू शकता.'
    },
    summons: {
      q: 'मला कोर्टाचे समन्स आले आहे. मी काय करू?',
      a: 'समन्समध्ये लिहिलेले असते की तुम्हाला कोणत्या तारखेला कोर्टात यायचे आहे. तुम्ही पात्र असाल, तर केसच्या कोणत्याही टप्प्यावर मोफत वकील मिळू शकतो: 15100 वर कॉल करा किंवा तुमच्या जिल्हा न्यायालयातील विधी सेवा कार्यालयात जा. तुमची केस आणि पुढची तारीख eCourts वेबसाइट किंवा ॲपवर पाहू शकता.'
    },
    case_status: {
      q: 'माझ्या कोर्ट केसची स्थिती (स्टेटस) कशी पाहू?',
      a: 'services.ecourts.gov.in वर जा, किंवा eCourts Services ॲप वापरा, आणि तुमच्या 16-अंकी CNR नंबरने किंवा केसच्या इतर माहितीने शोधा. SMS सुद्धा पाठवू शकता: ECOURTS, मग एक स्पेस, मग तुमचा CNR नंबर लिहून 9766899899 वर पाठवा.'
    },
    lok_adalat: {
      q: 'लोक अदालत म्हणजे काय?',
      a: 'लोक अदालत दोन्ही बाजूंच्या संमतीने केस मिटवते. यात कोणतीही कोर्ट फी लागत नाही, आणि कोर्टात चालू असलेली केस इथे मिटली, तर भरलेली कोर्ट फी परत मिळते. हिचा निर्णय कोर्टाच्या हुकूमनाम्यासारखा (डिक्री) अंतिम आणि बंधनकारक असतो, आणि त्याविरुद्ध अपील करता येत नाही.'
    },
    rti: {
      q: 'RTI अर्ज कसा करू?',
      a: 'केंद्र सरकारच्या कार्यालयांसाठी rtionline.gov.in वर ऑनलाइन अर्ज करा. फी ₹10 आहे; तुम्ही दारिद्र्यरेषेखालील (BPL) असाल तर फी नाही (तुमचे BPL प्रमाणपत्र जोडा). अधिकाऱ्याने 30 दिवसांत उत्तर द्यायला हवे, आणि एखाद्याच्या जीविताचा किंवा स्वातंत्र्याचा प्रश्न असेल तर 48 तासांत. 30 दिवसांत उत्तर मिळाले नाही, तर पुढच्या 30 दिवसांत मोफत पहिले अपील करू शकता.'
    },
    grievance: {
      q: 'सरकारी कार्यालय माझे काम करत नाही. तक्रार कुठे करू?',
      a: 'pgportal.gov.in वर CPGRAMS मध्ये तक्रार नोंदवा — हे दिवस-रात्र खुले असते (याचे ॲपही आहे, आणि UMANG वरही आहे). 21 दिवसांत तक्रार सोडवण्याचे लक्ष्य आहे. यात RTI ची प्रकरणे, कोर्ट केस, धार्मिक बाबी किंवा सरकारी कर्मचाऱ्यांच्या सेवेसंबंधी बाबी घेतल्या जात नाहीत.'
    }
  }
}
